import TypographyTsoPq from '@components/Typography/TypographyTsoPq';
import { AccordionContentWrapper, StyledButtonTsoPq } from '../StyledUploadDataComponents';
import { tsoPqTheme } from '@assets/style/customTsoPqtheme';

const AccordionContent = ({
  title,
  content,
  label,
  handler,
}: {
  title: string;
  content: string;
  label?: string;
  handler?: () => void;
}) => {
  return (
    <AccordionContentWrapper>
      <TypographyTsoPq
        color={tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_enabled}
        typographyType={'sectionTitleSMBold'}
      >
        {title}
      </TypographyTsoPq>
      <TypographyTsoPq typographyType="bodyTextSM">{content}</TypographyTsoPq>
      {label && <StyledButtonTsoPq buttonType={'filledPrimary'} textContent={label} onClick={handler} />}
    </AccordionContentWrapper>
  );
};

export default AccordionContent;
